<template>
  <div class="input-field-datetime" :id="componentId">
    <div class="input-field-datetime__container" :class="{ 'error': showError ,'disabled': disabled}">
      <div class="input-field-datetime__container__input" :class="{'error': showError ,'disabled': disabled}">
        <Datepicker
          ref="datepickerRef"
          class="input-datetime"
          v-model="model"
          format="dd/MM/yyyy"
          type="date"
          :language="vi"
          :disabled-dates="disabledDates"
          :disabled="disabled"
          @selected="handleChange">
        </Datepicker>
        <label @click="handleOpen" :class="model? 'small':''" :for="name">{{ labelName }}</label>
      </div>
      <slot name="prependIcon"></slot>
    </div>
    <div class="error-message" :class="{ 'active': showError }">{{ errorMessage }}</div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {vi} from 'vuejs-datepicker/dist/locale'

export default {
  name: "Datetime",
  components: {
    Datepicker
  },
  data() {
    return {
      momentFormat:{
        stringify: (date) => {
          return date ? moment(date).format('LL') : ''
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, 'LL').toDate() : null
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          return // a number
        }
      },
      model: this.initValue ? this.initValue : null,
      vi:vi,
      disabledDates:{
        from:new Date()
      } 
    };
  },
  props: {
    componentId: {
      type: [String, null],
      default: null
    },
    initValue: {
      type: Date
    },
    type: {
      type: String
    },
    name: {
      type: String
    },
    labelName: {
      type: String
    },
    maxlength: {
      type: String
    },
    minlength: {
      type: String
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    onBlur: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("onChange", value);
    },
    handleSubmit ($event) {
      this.$emit("onSubmit", $event);
    },
    handleBlur() {
      this.$emit("onBlur", this.model || '');
    },
    handleOpen(){
      if(this.$refs.datepickerRef && !this.disabled){
        this.$refs.datepickerRef.showDayCalendar()
      }
    }
  },
  watch: {
    model (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("onChange", newVal);
      }
    }
  },
}
</script>

<style lang="scss">
.vdp-datepicker__calendar .cell.selected{
    background-color:  #ff8200 !important;
  
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{
  border: 1px solid #ff8200 !important;
}
.input-field-datetime {
  width: 100%;

  &__container {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #E5E7E8;
    background-color: #FFFFFF;

    &.error {
      border: 1px solid #ff5252;
      background-color: #E8313B0D;
      input{
        background-color: transparent;
      }
    }
    &.disabled{
      background-color: #f8f8f8;
    }
  }
  
}

.input-field-datetime__container__input {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  // margin-bottom: 15px;

  label {
    position: absolute;
    top: 0;
    left: px;
    width: 100%;
    color: #7a8189;
    padding: 0 12px;
    transition: 0.2s all;
    font-size: 14px;
    cursor: text;
  }
  input {
    width: 100%;
    height: 46px;
    outline: 0;
    border-radius: 4px;
    background-color: #ffffff;
    border: none;
    font-size: 14px;
    padding: 25px 12px 0 12px;
    color: #1a1a1a;
    &[disabled]{
      background-color: #f8f8f8;
    }
  }

  input:invalid {
    outline: 0;
  }
  .input-datetime:has( input:focus ) ~ label,
  .input-datetime:has( input:valid ) ~ label {
    font-size: 10px;
    top: -12px;
    color: #7a8189;
    height: 0px;
  }
  .small{
    font-size: 10px;
    top: -15px;
    color: #7a8189;
    height: 0px;
  }
  &.disabled{
    background-color: #f8f8f8;
  }
}
.error-message {
  font-size: 12px;
  color: #ff5252;
  display: none;
}
.error-message.active {
  display: block;
}
</style>
<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
